import React from "react";
import { Typography, Link, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#fff',
  }
}));

const Copyright = () => {
  const classes = useStyles();
  return (
    <Box mt={8}>
      <Typography className={classes.root} variant="body2" color="textPrimary" align="center">
        {"Copyright © "}
        <Link color="inherit" href="">
          Deixa Que Eu Procuro
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Box>
  );
};

export default Copyright;
